<template>
  <!-- 待外发录入列表 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="addNotice()"
          v-permission="'admin:xiaoxitongzhi:add'"
          >新建消息</el-button
        >
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="delNotice()"
          v-permission="'admin:xiaoxitongzhi:del'"
          >删除</el-button
        >
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <!-- 表格 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <mytable
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isselection="true"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :fieldList="fieldList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      :showFilter="true"
      @fildsClick="fildsClick"
    >
    </mytable>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageStart"
      :page-size="pageTotal"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageCount"
    >
    </el-pagination>
    <myDialog
      diaWidth="1400px"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="isShowDialog = false"
      height-lock
      body-full
      @diaConfirmBtn="diaConfirm"
      @diaCancelBtn="isShowDialog = false"
    >
      <el-form
        :model="params"
        style="padding: 10px 20px"
        label-position="left"
        label-width="60px"
      >
        <el-form-item prop="sendName" label="发送人">
          <el-input
            v-model="params.sendName"
            :disabled="!editable"
            style="width: 200px"
          ></el-input>
        </el-form-item>
        <el-form-item prop="userIds" label="接收人">
          <el-select
            v-model="params.userIds"
            multiple
            placeholder="请选择"
            clearable
            filterable
            remote
            :remote-method="getUsers"
          >
            <el-option
              v-for="user in users"
              :key="user.id"
              :label="user.name"
              :value="user.id"
            >
              <!-- <span style="float: left">{{ emp.jobNumber }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">{{
                emp.employeeName
              }}</span> -->
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="msgMainTitle" label="标题">
          <el-input
            v-model="params.msgMainTitle"
            :disabled="!editable"
          ></el-input>
        </el-form-item>
        <el-form-item prop="msgContent" label="内容">
          <el-input
            type="textarea"
            rows="8"
            v-model="params.msgContent"
            :disabled="!editable"
          ></el-input>
        </el-form-item>
      </el-form>
    </myDialog>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js";
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import queryBtns from "@/components/queryBtns.vue";
import queryCondition from "@/components/queryCondition.vue";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import mytable from "@/components/table/table.vue";
import myDialog from "@/components/Dialog.vue";
export default {
  mixins: [tableListNew, exportjs],
  inject: ["reload"],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    mytable,
    myDialog,
  },
  data() {
    return {
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      pageGroupName: "notice_list", //  页面标识
      reportFiledsNumber: "notice_list", // 动态 条件、表头
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "editNotice", //当前页面的方法
          param: 1, //自定义参数标记,
          permission: "admin:xiaoxitongzhi:edit",
        },
        {
          name: "查看",
          methods: "detail",
          param: 2,
          permission: "admin:xiaoxitongzhi:detail",
        },
        {
          name: "发送",
          methods: "sendNotice",
          param: 1,
          permission: "admin:xiaoxitongzhi:send",
        },
        {
          name: "删除",
          methods: "delNotice",
          param: 1,
          permission: "admin:xiaoxitongzhi:del",
        },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      //需要单独点击的列字段名数组
      fieldList: ["waybillNumber"],
      Operatewidth: "200px", //操作列的列宽
      // 表格右边更多的操作按钮
      btnsMoreList: [],
      dialogTitle: "新建消息",
      conditions: {
        languange: "zh-CN",
      },
      isShowDialog: false,
      params: {},
      immediate: true,
      users: [],
      editable: false,
    };
  },
  mounted() {
    this.getUsers();
  },
  watch: {},
  methods: {
    async getUsers(userName) {
      const res = await this.$API.runList({
        number: "down_list_user",
        userName
      });
      this.users = res;
    },
    // 新增、 修改 、查看
    addNotice() {
      this.isShowDialog = true;
      this.dialogTitle = "新建消息";
      this.editable = true;
    },
    editNotice(row) {
      this.isShowDialog = true;
      this.dialogTitle = "修改消息";
      this.params = {
        ...row,
        userIds: row.receiveUserId.split(",").map((item) => parseInt(item)),
      };
      this.editable = true;
    },
    sendNotice(row) {
      if (!row && this.selectTableData.length === 0) {
        this.$message.warning("请选择需要发送的消息");
      }
      let notices = [];
      if (row) {
        notices = [row];
      } else {
        notices = this.selectTableData;
      }
      this.$confirm("确认要发布所选数据？").then((res) => {
        this.$API
          .sendNotice({
            draftIds: notices.map((item) => item.draftId),
          })
          .then((re) => {
            this.$message.success("发送成功");
            this.getData();
          });
      });
    },
    detail(row) {
      this.isShowDialog = true;
      this.editable = false;
      this.dialogTitle = "消息详情";
      this.params = {
        ...row,
        userIds: row.receiveUserId.split(",").map((item) => parseInt(item)),
      };
    },
    delNotice(row) {
      if (!row && this.selectTableData.length === 0) {
        this.$message.warning("请选择需要删除的消息");
        return;
      }
      let notices = [];
      if (row) {
        notices = [row];
      } else {
        notices = this.selectTableData;
      }
      this.$confirm("是否确定要删除改消息")
        .then((res) => {
          this.$API
            .delNotice({
              draftIds: notices.map((item) => item.draftId),
            })
            .then((re) => {
              this.$message.success("删除消息");
              this.getData();
            });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    diaConfirm() {
      if (!this.editable) {
        this.isShowDialog = false;
      }
      if (this.params.draftId) {
        this.submitEdit();
      } else {
        this.submitAdd();
      }
      this.editable = false;
    },
    submitAdd() {
      this.$API
        .addNotice({
          ...this.params,
          isSend: 0,
          noticeCategory: "noticeCategory",
        })
        .then((res) => {
          this.$message.success("保存成功");
          this.getData();
          this.isShowDialog = false;
          this.params = {};
        })
        .catch((err) => {});
    },
    submitEdit() {
      this.$API
        .updateNotice({
          ...this.params,
          isSend: 0,
          noticeCategory: "noticeCategory",
        })
        .then((res) => {
          this.$message.success("保存成功");
          this.getData();
          this.isShowDialog = false;
          this.params = {};
        })
        .catch((err) => {});
    },
  },
};
</script>
<style scoped lang="less">
.container {
  height: calc(100vh - 80px);
  overflow: hidden;
  display: flex;
  flex-flow: column;
}
</style>